import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { RouteKeys } from '../routes/route-keys';
import { logoutAction } from '../../core';
import api from '../../api';

const IdleTimer = () => {
    const [isIdle, setIsIdle] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertTimeout, setAlertTimeout] = useState<any>(null);
    const [logoutTimeout, setLogoutTimeout] = useState<any>(null);
    const [countdown, setCountdown] = useState(60);
    const [logout, setLogout] = useState<boolean>(false);
    const dispatch = useDispatch();
    const history = useHistory();

    // Define your idle timeout duration in milliseconds
    const IDLE_TIMEOUT_DURATION = 29 * 60 * 1000  // 29 minutes
    const ALERT_TIMEOUT_DURATION = 60000; // 1 minute
    const LAST_ACTIVITY_KEY = 'lastActivity';

    const logOutStatus = localStorage.getItem('logoutStatus');

    useEffect(() => {
        let idleTimeout: NodeJS.Timeout;
        // let alertTimeout;

        // Reset the idle timeout whenever there's user activity
        const resetIdleTimeout = () => {
            if (idleTimeout) {
                clearTimeout(idleTimeout);
                localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
                localStorage.setItem('logoutStatus', 'No');
            }

            idleTimeout = setTimeout(() => {
                const lastActivityTimestamp = localStorage.getItem(LAST_ACTIVITY_KEY);
                if (lastActivityTimestamp && Date.now() - parseInt(lastActivityTimestamp, 10) < IDLE_TIMEOUT_DURATION) {
                    clearTimeout(idleTimeout);
                } else {
                    const status = localStorage.getItem('logoutStatus');
                    if (status && status === 'Yes') {
                        handleLogout();
                    }
                    setIsIdle(true);
                    setShowAlert(true);
                }

            }, IDLE_TIMEOUT_DURATION);
        };

        // Start the idle timeout
        resetIdleTimeout();

        // Listen to user activity events
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
        events.forEach(event => {
            window.addEventListener(event, resetIdleTimeout);
            localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
            localStorage.setItem('logoutStatus', 'No');
        });

        // Clear the idle timeout and remove event listeners when component unmounts
        return () => {
            if (idleTimeout) {
                clearTimeout(idleTimeout);
            }

            events.forEach(event => {
                window.removeEventListener(event, resetIdleTimeout);
            });
        };
    }, []);

    // useEffect(() => {
    //     if (showAlert) {
    //         setAlertTimeout(setTimeout(handleAlertTimeout, ALERT_TIMEOUT_DURATION));
    //     } else {
    //         clearTimeout(alertTimeout);
    //     }

    //     return () => {
    //         clearTimeout(alertTimeout);
    //     };
    // }, [showAlert]);

    // const handleAlertTimeout = () => {
    //     setCountdown(60);
    //     setShowAlert(false);
    //     handleLogout();
    // };

    const handleContinue = async () => {
        setIsIdle(false);
        setShowAlert(false);
        clearTimeout(alertTimeout);
        setCountdown(60)
        await api.notification.getNotifications(1, 10);
    };

    const handleLogout = () => {
        localStorage.setItem('logoutStatus', 'Yes');
        setLogout(true);
        setIsIdle(false);
        setShowAlert(false);
        clearTimeout(alertTimeout);
        setCountdown(60)
        dispatch(logoutAction());
        history.push(RouteKeys.Login);
    };

    //   useEffect(() => {
    //     if (isIdle) {
    //       setLogoutTimeout(setTimeout(handleLogout, 60000)); // Auto logout after 1 minute of being idle
    //     } else {
    //       clearTimeout(logoutTimeout);
    //     }

    //     return () => {
    //       clearTimeout(logoutTimeout);
    //     };
    //   }, [isIdle]);

    useEffect(() => {
        if (isIdle && !logout) {
            setLogoutTimeout(setTimeout(handleLogout, ALERT_TIMEOUT_DURATION)); // Auto logout after 1 minute of being idle
        } else {
            clearTimeout(logoutTimeout);
        }

        return () => {
            clearTimeout(logoutTimeout);
        };
    }, [isIdle, logout]);

    useEffect(() => {
        if (isIdle) {
            const timer = setInterval(() => {
                setCountdown(prevCountdown => prevCountdown - 1);
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [isIdle]);

    // window.addEventListener('storage', (event) => {
    //     console.log('event', event)
    //     // if (event.key === 'logout') {
    //     //   // Check if the logout event is recent (within a few seconds)
    //     //   const logoutTime = parseInt(event.newValue);
    //     //   const currentTime = Date.now();
    //     //   if (currentTime - logoutTime < 5000) { // 5 seconds threshold
    //     //     // Do nothing, as another tab has already initiated logout
    //     //     // or you can trigger some UI notification
    //     //   }
    //     // }
    // });

    return (
        <div>
            {isIdle && showAlert && (
                <>
                    <div
                        className="modal fade show in"
                        id="exampleModal"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
                            <div className="modal-content rounded-0">
                                <div className="modal-body text-center">
                                    <div className="container">
                                        <div className='row d-flex justify-content-center py-2 row session-timeout-popup'>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40" fill=''>
                                                <path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z" />
                                            </svg>
                                        </div>
                                        <div className="row">
                                            <div className="col font-weight-semibold">
                                                <p>Session Timeout Warning</p>
                                            </div>
                                        </div>
                                        <p>Your session will expire in {countdown} seconds.</p>
                                        <div className="d-flex align-items-center justify-content-center">
                                                <button
                                                    className="btn btn-primary py-2 font-weight-semibold font-normal px-4 mr-3 w-100"
                                                    onClick={handleContinue}
                                                // disabled={updating}
                                                >
                                                    Continue
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 w-100"
                                                    onClick={handleLogout}
                                                // disabled={updating}
                                                >
                                                    Logout
                                                </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            )} 
        </div>
    );
}

export default IdleTimer;
